import { useState } from 'react';
import styles from '~/styles/components/product/product-primary-info.module.scss';
import Button from './button';
import { useGlobalState } from '../state';
import { ActionType } from '../state/types';

interface Props {
  successMessage: string;
  failedMessage: string;
  title: string;
  description: string;
  showBackendError?: boolean;
  functionToExecute: () => any;
}
export default function AdminActionModal(props: Props) {
  const { dispatch } = useGlobalState();
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [failed, setFailed] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  async function handleExecuteAction() {
    setLoading(true);
    setSuccess(false);
    setFailed(false);
    try {
      await props.functionToExecute();
      setSuccess(true);
    } catch (e: any) {
      setFailed(true);
      setErrorMessage(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className={styles['modal-title']}>
        {success
          ? 'Success'
          : failed
            ? 'Something went wrong'
            : props.title}
      </div>
      <div className={styles['modal-spacer']} />
      <div className={styles['modal-message']}>
        {success
          ? props.successMessage
          : failed
            ? props.showBackendError ? errorMessage : props.failedMessage
            : props.description}
      </div>
      <div className={styles['modal-spacer']} />
      <div>
        <Button
          text='Cancel'
          style='secondary'
          disabled={loading}
          onPress={() => dispatch({ type: ActionType.FLUSH_MODAL_DATA })}
        />
      </div>
      <div className={styles['modal-spacer']} />
      <div>
        <Button
          text={success ? 'Close' : props.title}
          disabled={loading}
          loading={loading}
          onPress={
            success
              ? () => dispatch({ type: ActionType.FLUSH_MODAL_DATA })
              : handleExecuteAction
          }
        />
      </div>
    </div>
  );
}